<template>
    <div class="login">
        <Header tit="注册" color="1"></Header>
        <div class="tit_e">注册</div>

        <!-- <form> -->
        <div class="register_box box_shadow">
            <div class="input_bar">
                <div class="item">
                    <div class="tit">手机号</div>
                    <input type="text" v-model="phone"   maxlength="10" placeholder="请输入手机号" />
                </div>
                <div class="item get_code">
                    <div class="tit">图形验证码</div>
                    <input type="text" v-model="img_code" placeholder="请输入图形验证码" />
                    <img :src="$path.captcha" alt />
                </div>
                <!-- <div class="item get_code">
                    <div class="label">短信验证码</div>
                    <input type="text" v-model="sms_code" placeholder="请输入验证码" />
                    <button
                        @click="sendRegSms"
                        :disabled="code_count_down != 0"
                        class="syellow_color"
                    >{{code_count_down > 0 ? code_count_down+ 's后可发送' : '获取验证码'}}</button>
                </div> -->
                <div class="item">
                    <div class="tit">登录密码</div>
                    <input type="password" v-model="password" placeholder="请设置 6-16 位密码" />
                </div>
                <div class="item">
                    <div class="tit">邀请码</div>
                    <input type="text" v-model="invite_code" placeholder="邀请码" />
                </div>
            </div>
        </div>
        <BigBtn @click="click_BigBtn" class="btn" label="注册"></BigBtn>
        <div class="go_login" @click="go_login">已有账号？去登录</div>
        <!-- </form> -->
    </div>
</template>

<script>
import Header from "../public/header";
import BigBtn from "../public/button";
export default {
    components: { Header, BigBtn },
    data() {
        return {
            phone: "", //类型：String  必有字段  备注：无
            password: "",
            sms_code: "888888", //类型：String  必有字段  备注：验证码
            img_code: "", //类型：String  必有字段  备注：验证码
            invite_code:"",
            code_count_down: 0, //验证码倒计时
            play: null //验证码定时器
        };
    },
    methods: {
        forget() {
            this.$router.push({ name: "forget" });
        },
        //发送验证码
        sendRegSms() {
            if (!this.img_code) {
                return this.$alert("请输入图形验证码！");
            }
            this.$post(this.$path.mobilecode, {
                code: this.img_code
            }).then(res => {
                if (res.success) {
                    this.$alert("发送成功");
                    this.code_count_down = 60;
                    this.count_down();
                }
            });
        },
        count_down() {
            this.play = setInterval(() => {
                if (this.code_count_down > 0) {
                    this.code_count_down--;
                } else {
                    clearInterval(this.play);
                }
            }, 1000);
        },
        go_login() {
            this.$router.go(-1);
        },
        //注册
        click_BigBtn() {
            if (this.password1 !== this.password2) {
                return this.$alert("两次输入的密码不一致！");
            }
            
            if (!this.phone || this.phone.length<9 || this.phone.length>10) {
               // return this.$alert("请输入手机号！");
                return this.$alert("手机号长度应为 9-10 位！");
            }
            if (!this.password || this.password.length<6) {
                return this.$alert("请输入密码！");
            }
            if (!this.sms_code) {
                return this.$alert("请输入短信验证码！");
            }
            if (!this.img_code) {
                return this.$alert("请输入图形验证码！");
            }
            
            if (!this.invite_code) {
                return this.$alert("请输入邀请码！");
            }
            this.$post(this.$path.register, {
                mobile: this.phone,
                pass: this.password,
                mobile_code: this.sms_code,
                code: this.img_code,
                invite_code:this.invite_code
            }).then(res => {
                debugger
                if (res.success) {
                    this.$alert("注册成功");
                    setTimeout(() => {
                        //this.$router.push({ name: "my" });
                        this.$router.push({ path: "/my" });
                    }, 2000);
                }
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./login.scss";
.login {
    .get_code {
        border: none;
    }
    .register_box {
        width: 100%;
        background: #ffffff;
        border-radius: 0.2rem;
        .input_bar {
            padding-left: 0.3rem;
            background: #ffffff;
            border-radius: 0.16rem;
            margin-top: 0.3rem;
            .item {
                width: 100%;
                height: 1.16rem;
                border-bottom: 1px #e5e5e5 solid;
                .label {
                    width: 1.8rem;
                    height: 100%;
                    line-height: 1.1rem;
                    font-size: 0.32rem;
                    float: left;
                }
                input {
                    float: left;
                    margin-left: 0.2rem;
                    width: 4rem;
                    height: 100%;
                    margin-top: 0;
                }
            }
            .get_code {
                display: flex;
                flex-direction: row;
                input {
                    width: 2.75rem;
                }
                button {
                    width: 1.6rem;
                    height: 0.64rem;
                    border: 1px #bc7c1c solid;
                    background: none;
                    border-radius: 0.4rem;
                    margin-top: 0.26rem;
                    margin-right: 0.2rem;
                    font-size: 0.2rem;
                }
                img{
                    width: 1.6rem;
                    height: .6rem;
                    margin-top: .28rem;
                }
            }
            .no_border {
                border: none;
            }
        }
    }
    .go_login {
        color: #666666;
        margin-top: -0.2rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue